import { HeaderMetaModel } from 'src/app/share/models/header/header.model';

	export const defaultCountry: Array<HeaderMetaModel> =[
		{title: 'Hong Kong', titleKey: 'hong.kong', external: 'https://www.fsmone.com.hk'},
		{title: 'Singapore', titleKey: 'singapore', external: 'https://secure.fundsupermart.com/fsm/home'},
		{title: 'Malaysia', titleKey: 'malaysia', external: 'https://www.fsmone.com.my'}
	]